import { Entities } from '@inwink/entities/entities';
import { VisualTheme } from '@inwink/entities/visualtheme';

export const toEntityLabel: VisualTheme.IBindingConverterCallback = (val, properties, data, datacontext, i18n) => {
    const i18nHelper: Entities.i18nHelper = datacontext?.i18nHelper || i18n;
    if (i18nHelper) {
        const key = val && ((properties && properties.prefix) + val).toLowerCase();
        return i18nHelper.translate(key);
    }
    return val as any;
};